<button
  #toggleButton
  type="button"
  class="rcm-date-picker__toggle"
  aria-label="Pick a date"
  [attr.aria-expanded]="open"
  [attr.aria-controls]="popoverId"
  (click)="toggle()"
>
  <nova-icon name="calendar_month" [size]="24"></nova-icon>
</button>

<div
  class="rcm-date-picker__popover"
  [id]="popoverId"
  [class.rcm-date-picker__popover--open]="open"
>
  <nova-datepicker
    [inline]="true"
    (dateSelect)="onDateSelect($event)"
  ></nova-datepicker>
</div>
